
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    BULK_ADD_DRIVERID_TAGS_VALIDATE_REQUEST,
    BULK_ADD_DRIVERID_TAGS_IMPORT_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    bulkAddDriverIdTagsValidateIdsResult,
    bulkAddDriverIdTagsImportResult,
} from 'Redux/actions';

function* validateIds({ payload }) {
    try {
        let QUERY = `
            query searchKeyFobs ($conditions: [KeyFobSearchInput], $sort: [KeyFobSortInput], $limit: Int, $offset: Int) {
                result: searchKeyFobs (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        hex
                        driverId
                        companyId
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["hex"],
                    terms: payload,
                    exact: true
                },
                limit: 200,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result
            yield put(bulkAddDriverIdTagsValidateIdsResult(items))
        } else yield put(bulkAddDriverIdTagsValidateIdsResult([]))

    } catch (exc) {
        yield put(bulkAddDriverIdTagsValidateIdsResult([]))
        ExceptionManager(exc, 'Modules/keysFobs/.components/bulkAddDriverIdTahs/redux/saga', 'validateIds');
    }
}

function* importKeyFobs({ payload }) {
    try {
        let QUERY = `
            mutation importKeyFobs ($companyId: Int!, $keyFobs: [KeyFobInput]!) {
                result: importKeyFobs (companyId: $companyId, keyFobs: $keyFobs)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(bulkAddDriverIdTagsImportResult(data?.result))
        } else yield put(bulkAddDriverIdTagsImportResult())

    } catch (exc) {
        yield put(bulkAddDriverIdTagsImportResult({ error: exc }))
        ExceptionManager(exc, 'Modules/keysFobs/.components/bulkAddDriverIdTahs/redux/saga', 'importKeyFobs');
    }
}

function* watchMethods() {
    yield takeEvery(BULK_ADD_DRIVERID_TAGS_VALIDATE_REQUEST, validateIds);
    yield takeEvery(BULK_ADD_DRIVERID_TAGS_IMPORT_REQUEST, importKeyFobs);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}